<template>
  <div class="desktop-view" align="center" >
    <div :id="containerId" class="embedContainer" />
  </div>
</template>

<script>
import axios from 'axios';
import * as pbi from 'powerbi-client';

export default {
  name: 'PbiReport_MA_33_2_Mobile',
  components: {
  },

  props: [
    'width',
    'height',
  ],

  data() {
    return {
      pbiEmbedConfig: '',
      report: null,
      resizeDebounceTimeout: null,
    };
  },

  methods: {
    applyFilters() {
      console.log('set report filter MA332');

      if (this.report != null) {
        if (this.filters.length > 0) {
          this.report.setFilters(this.filters)
            .catch((errors) => {
              console.log(errors);
            // Handle error
            });
        } else {
          console.log('clearing filter');
          this.report.removeFilters();
        }
      } else {
        console.log('skipping filter set because report is null');
      }
    },


    reportLoaded() {
      // we raise an event for the parent page
      this.$emit('loaded');
      this.applyFilters();
    },


    sliceyDicey() {
      // slicer tests (DEBUG)
      this.report.getPages()
        .then((pages) => {
          let myPage = null;
          pages.forEach((page) => {
            page.hasLayout(pbi.models.LayoutType.MobilePortrait).then((hasLayout) => {
              console.log(hasLayout);
            });
            if (page.name === 'ReportSection') {
              myPage = page;
              console.log(`${page.name} - ${page.displayName} <- this page`);
            }
          });

          myPage.getVisuals()
            .then((visuals) => {
              visuals.forEach((visual) => {
                console.log(visual);
              });
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    processWindowResize() {
      if (this.resizeDebounceTimeout != null) {
        clearTimeout(this.resizeDebounceTimeout);
      }

      this.resizeDebounceTimeout = setTimeout(() => {
        if (document.getElementById(this.containerId) != null) {
          const width = document.getElementById(this.containerId).offsetWidth;
          const height = document.getElementById(this.containerId).offsetHeight;

          console.log(`resized! ${width} x ${height}`);
        } else {
          console.log('Skipped resize - container is null, page MA331Mobile');
        }

      // const newSettings = {
      //   // Settings accounting for custom layout with new size
      // };
      // visual.updateSettings(newSettings);
      }, 1000);
    },

  },

  computed: {
    // report IDs
    workspaceId() {
      return this.environment.workspaceId;
    },
    reportId() {
      return this.environment.reports.ma332Mobile.reportId;
    },
    reportPage() {
      return this.environment.reports.ma332Mobile.pageId;
    },


    // filter arrays
    yr() {
      return this.$store.getters['year/selectedValueArray'];
    },
    vt() {
      return this.$store.getters['valueType/selectedValueArray'];
    },
    vm() {
      return this.$store.getters['valueMeasure/selectedValueArray'];
    },
    // mcs() {
    //   return this.$store.getters['global/marketClassificationsArray'];
    // },
    rs() {
      return this.$store.getters['region/selectedValueArray'];
    },


    filters() {
      const filters = [{
        $schema: 'http://powerbi.com/product/schema#basic',
        target: {
          table: 'DimCalendar',
          column: 'Year',
        },
        operator: 'In',
        values: this.yr,
      }];

      // filters.push({
      //   $schema: 'http://powerbi.com/product/schema#basic',
      //   target: {
      //     table: 'FactIWSR',
      //     column: 'ValueType',
      //   },
      //   operator: 'In',
      //   values: this.vt,
      // });

      // if (this.mcs.length > 0) {
      //   filters.push({
      //     $schema: 'http://powerbi.com/product/schema#basic',
      //     target: {
      //       table: 'DimCountry',
      //       column: 'Market Classification',
      //     },
      //     operator: 'In',
      //     values: this.mcs,
      //     filterType: pbi.models.FilterType.BasicFilter,
      //   });
      // }

      if (this.rs.length > 0) {
        filters.push({
          $schema: 'http://powerbi.com/product/schema#basic',
          target: {
            table: 'DimCountry',
            column: 'Region',
          },
          operator: 'In',
          values: this.rs,
          filterType: pbi.models.FilterType.BasicFilter,
        });
      }

      // debug code
      console.log('filters:');
      for (let i = 0; i < filters.length; i += 1) {
        console.log(`---${filters[i].target.table}---${filters[i].target.column}`);
        for (let j = 0; j < filters[i].values.length; j += 1) {
          console.log(`------${filters[i].values[j]}`);
        }
      }

      return filters;
    },


    containerId() {
      return `embeddedContent${this.reportId}`;
    },

    environment() {
      return this.$store.state.global.environment;
    },
  },

  watch: {
    // vt: {
    //   handler(val) {
    //     console.log('detected change in type');
    //   },
    // },

    // mcs: {
    //   handler(val) {
    //     console.log('detected change in market classifications');
    //   },
    // },

    filters: {
      handler() {
        console.log('report detected filter change');
        this.applyFilters();
      },
      deep: true,
    },
  },

  async mounted() {
    console.log('MOUNTED 332');
    await axios
      .post(`https://${this.environment.apiUrl}/api/token`, {
        workspaceId: this.workspaceId,
        reportId: this.reportId,
      })
      .then((response) => {
        this.pbiEmbedConfig = response.data;
      })
      .catch(error => (console.log(`Error querying API for embed config: ${error.data}`)));

    // const accessToken = this.pbiEmbedConfig.;

    console.log('AWAIT COMPLETE 332');

    // check if the page is still loaded and if not abort
    // (this is because occasionally we get here after the user has navigated to a different page)
    if (document.getElementById(this.containerId) == null) {
      return;
    }

    const { models } = pbi;

    // Get embedContainer width and height
    console.log(`debug: container -> ${this.containerId}`);
    const pageWidth = document.getElementById(this.containerId).offsetWidth;
    const pageHeight = document.getElementById(this.containerId).offsetHeight;

    console.log(`dims: ${pageWidth} x ${pageHeight}`);

    const config = {
      // minimum params
      type: 'report',
      embedUrl: this.pbiEmbedConfig.embedUrl,
      tokenType: models.TokenType.Embed,
      accessToken: this.pbiEmbedConfig.embedToken.token,
      id: this.reportId,
      pageName: this.reportPage,

      permissions: models.Permissions.Read, // open read-only
      viewMode: models.ViewMode.View, // open in view mode
      settings: {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        background: models.BackgroundType.Transparent,
        layoutType: models.LayoutType.Custom,
        customLayout: {
          displayOption: models.DisplayOption.FitToPage,
          pagesLayout: {
            ReportSection: {
              defaultLayout: {
                displayState: {
                  mode: models.VisualContainerDisplayMode.Visible,
                },
              },
              visualsLayout: {
              },
            },
          },
        },
      },
      filters: [], // set this to programatically apply filters
    };

    const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

    const embedContainer = document.getElementById(this.containerId);
    this.report = powerbi.embed(embedContainer, config);


    this.report.on('loaded', () => {
      this.reportLoaded();
    });

    this.report.on('rendered', () => {
      console.log('handled rendered');

      // debug
      this.sliceyDicey();
    });

    this.report.on('dataSelected', () => {
      console.log('handled dataSelected');
    });

    this.report.on('filtersApplied', () => {
      console.log('handled filters applied');
    });

    // add a resize event handler with debounce
    window.addEventListener('resize', this.processWindowResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.processWindowResize);
  },


};

</script>


<style scoped>

.embedContainer {
    width: 100%;
    height: calc(6 * 100vw);
    background-color: white;
    padding: 0px;
    clear: both;
}
.desktop-view iframe, .mobile-view iframe {
    border: none;
}

</style>
